module.exports = __webpack_public_path__ + "media/images/number01-e5768bf3523bf4025f03a83dc41f663b.svg";